import { UpdateChannelInput } from "../../../../rpcs/dist/ChannelRPC"
import { UpdateUserInput } from "../../../../rpcs/dist/UserRPC"
import Color from "../../../../style/enum/color"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCamera } from "@fortawesome/free-solid-svg-icons"
import React from "react"
import styled from "styled-components"
import { ButtonStyle } from "../button"
import {
  InputImageFile,
  SUPPORTED_IMAGE_MIME_TYPE,
} from "../../../../libs/input-image-file"
import { ChangeEvent } from "react"
import { Error } from "../../form-error-string-wrapper"

export type IImageData = NonNullable<UpdateChannelInput["image"]> &
  NonNullable<UpdateUserInput["profileImage"]>

interface IProps {
  receiveImageData?: (imageData: IImageData) => void
}

interface IState {
  errorMessage: string | null
}

export class ChangeIconButton extends React.Component<IProps, IState> {
  private randId: string

  constructor(props: IProps) {
    super(props)
    this.randId = this.generateRandomKey()
    this.onChange = this.onChange.bind(this)
    this.state = {
      errorMessage: null,
    }
  }

  public render() {
    return (
      <StyledLabel htmlFor={this.randId}>
        <StyleButton
          borderColor={Color.DIMGRAY}
          color={Color.DIMGRAY}
          small={true}
        >
          <FontAwesomeIcon icon={faCamera} /> 画像を変更
        </StyleButton>
        {this.state.errorMessage && <Error>{this.state.errorMessage}</Error>}
        <FileInput
          id={this.randId}
          type="file"
          accept={SUPPORTED_IMAGE_MIME_TYPE.join(",")}
          onChange={this.onChange}
        />
      </StyledLabel>
    )
  }

  private async onChange({ target }: ChangeEvent<HTMLInputElement>) {
    if (!target.files) {
      return
    }

    await InputImageFile(target.files)
      .then(imageData => {
        if (imageData && this.props.receiveImageData) {
          this.props.receiveImageData(imageData)
        }
      })
      .catch(e => {
        this.setState({
          errorMessage: e.message,
        })
      })
  }

  private generateRandomKey(): string {
    const MULTIPLIER = Math.pow(2, 24)
    let key
    while (key === undefined || !isNaN(+key)) {
      key = Math.floor(Math.random() * MULTIPLIER).toString(32)
    }
    return key
  }
}

const StyledLabel = styled.label`
  margin-top: 10px;
  text-align: center;
`

const StyleButton = ButtonStyle.withComponent("div")

const FileInput = styled.input`
  display: none;
`
